import Skeleton from '@material-ui/lab/Skeleton';
import { memo } from 'react';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import styles from './styles.module.css';

const SliderProductBlock = memo(({ hiddenTitle = false }) => (
  <div className={styles.sliderProductBlockWrapper}>
    {/* <Grid container direction="row" justifyContent="center" alignItems="center">
      <Grid item>
        <Box display="flex" alignItems="center" justifyContent="center">
          <Skeleton variant="rect" animation="wave" className={styles.titleSliderProduct} />
        </Box>
      </Grid>
    </Grid> */}
    <div style={{ marginTop: hiddenTitle ? 0 : 40, marginBottom: hiddenTitle ? 40 : 0 }}>
      {!hiddenTitle && <Skeleton width="100%" height={70} />}
      <div className={styles.sliderWrapper}>
        <Skeleton variant="rect" animation="wave" className={styles.productCardSkeleton} />
        <Skeleton variant="rect" animation="wave" className={styles.productCardSkeleton} />
        <Skeleton variant="rect" animation="wave" className={styles.productCardSkeleton} />
        <Skeleton variant="rect" animation="wave" className={styles.productCardSkeleton} />
        <Skeleton variant="rect" animation="wave" className={styles.productCardSkeleton} />
      </div>
      {/* <Grid container direction="row" justifyContent="center" alignItems="center">
        <Grid item>
          <Box display="flex" alignItems="center" justifyContent="center">
            <Skeleton variant="rect" animation="wave" className={styles.buttonSliderProductSkeleton} />
          </Box>
        </Grid>
      </Grid> */}
    </div>
  </div>
));

export default SliderProductBlock;
